import React, { useEffect, useState } from "react";
import { db } from "../FireBase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { Bed, MountainIcon, TentIcon } from "lucide-react";
import { Button } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import RoomCard from "../components/FetRoomCard";
import FetPackageCard from "./FetPackages";
import '../css/FeturedList.css'
import FetSightSeeingCard from "./FetSightSeeingCard";

const FeaturedSightSeeings = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const bestSellerTagId = "Xb9aAWeCL4TO6lyYOnbQ";

  useEffect(() => {
    const fetchFeaturedPackages = async () => {
      setLoading(true);
      try {
        const q = query(
          collection(db, "sightseeing_packages"),
          where("tags", "array-contains", bestSellerTagId)
        );
        const querySnapshot = await getDocs(q);
        const fetchedPackages = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setPackages(fetchedPackages); // ✅ update state first
        console.log(fetchedPackages)
      } catch (error) {
        console.error("Error fetching featured packages:", error);
        setPackages([]);
      } finally {
        setLoading(false);
      }
    };
  
    fetchFeaturedPackages();
  }, []);
  
 
  
  return (
    <>
      <div className="d-flex justify-content-between align-items-center w-100">
        <h4 className="mb-4" style={{ color: '#0d3b66', fontWeight: 600 }}>
          Featured Sight-seeings
        </h4>
        <Link to="/cab-and-rental" style={{ textDecoration: 'none' }}>
          <Button className="btn-sm d-flex align-items-center btn-own" style={{ padding: '5px 12px' }}>
            <span style={{ marginRight: '6px' }}>Explore</span>
            <MountainIcon size={16} />
          </Button>
        </Link>
      </div>

      <div 
        className="d-flex gap-3 overflow-auto hide-scrollbar"
        style={{ scrollBehavior: "smooth" }}
      >
        {loading ? (
          [...Array(4)].map((_, idx) => (
            <div key={idx} style={{ width: '300px' }}>
              <Skeleton height={200} />
              <Skeleton height={20} />
              <Skeleton height={20} />
            </div>
          ))
        ) : (
          packages.slice(0, 10).map(pack => (
            <FetSightSeeingCard key={pack.id} pkg={pack}  />
          ))
        )}
      </div>
    </>
  );
};

export default FeaturedSightSeeings;
